module.exports = __webpack_public_path__ + "static/sala_capacitaciones.min-767ed9445cc7d59b497ffd11a36649a9.png";